export const GET_PARTY_LIST_REQUEST = "GET_PARTY_LIST_REQUEST";
export const GET_PARTY_LIST_SUCCESS = "GET_PARTY_LIST_SUCCESS";
export const GET_PARTY_LIST_FAILURE = "GET_PARTY_LIST_FAILURE";

export const GET_PARTY_ACCOUNT_LIST_REQUEST = "GET_PARTY_ACCOUNT_LIST_REQUEST";
export const GET_PARTY_ACCOUNT_LIST_SUCCESS = "GET_PARTY_ACCOUNT_LIST_SUCCESS";
export const GET_PARTY_ACCOUNT_LIST_FAILURE = "GET_PARTY_ACCOUNT_LIST_FAILURE";

export const GET_CATEGORY_REQUEST = "GET_CATEGORY_REQUEST";
export const GET_CATEGORY_SUCCESS = "GET_CATEGORY_SUCCESS";
export const GET_CATEGORY_FAILURE = "GET_CATEGORY_FAILURE";

export const GET_PRODUCT_GROUPS_REQUEST = "GET_PRODUCT_GROUPS_REQUEST";
export const GET_PRODUCT_GROUPS_SUCCESS = "GET_PRODUCT_GROUPS_SUCCESS";
export const GET_PRODUCT_GROUPS_FAILURE = "GET_PRODUCT_GROUPS_FAILURE";

export const GET_STYLE_COLOR_REQUEST = "GET_STYLE_COLOR_REQUEST";
export const GET_STYLE_COLOR_SUCCESS = "GET_STYLE_COLOR_SUCCESS";
export const GET_STYLE_COLOR_FAILURE = "GET_STYLE_COLOR_FAILURE";

export const SUBMIT_DIRECT_IMPORT_REQUEST = "SUBMIT_DIRECT_IMPORT_REQUEST";
export const SUBMIT_DIRECT_IMPORT_SUCCESS = "SUBMIT_DIRECT_IMPORT_SUCCESS";
export const SUBMIT_DIRECT_IMPORT_FAILURE = "SUBMIT_DIRECT_IMPORT_FAILURE";

export const PREPARE_FOR_EXPORT_REQUEST = "PREPARE_FOR_EXPORT_REQUEST";
export const PREPARE_FOR_EXPORT_SUCCESS = "PREPARE_FOR_EXPORT_SUCCESS";
export const PREPARE_FOR_EXPORT_FAILURE = "PREPARE_FOR_EXPORT_FAILURE";

export const GET_STYLE_PREFIX_REQUEST = "GET_STYLE_PREFIX_REQUEST";
export const GET_STYLE_PREFIX_SUCCESS = "GET_STYLE_PREFIX_SUCCESS";
export const GET_STYLE_PREFIX_FAILURE = "GET_STYLE_PREFIX_FAILURE";

export const GET_STYLE_SUFFIX_REQUEST = "GET_STYLE_SUFFIX_REQUEST";
export const GET_STYLE_SUFFIX_SUCCESS = "GET_STYLE_SUFFIX_SUCCESS";
export const GET_STYLE_SUFFIX_FAILURE = "GET_STYLE_SUFFIX_FAILURE";

export const GET_COLOR_PREFIX_REQUEST = "GET_COLOR_PREFIX_REQUEST";
export const GET_COLOR_PREFIX_SUCCESS = "GET_COLOR_PREFIX_SUCCESS";
export const GET_COLOR_PREFIX_FAILURE = "GET_COLOR_PREFIX_FAILURE";

export const GET_COLOR_SUFFIX_REQUEST = "GET_COLOR_SUFFIX_REQUEST";
export const GET_COLOR_SUFFIX_SUCCESS = "GET_COLOR_SUFFIX_SUCCESS";
export const GET_COLOR_SUFFIX_FAILURE = "GET_COLOR_SUFFIX_FAILURE";

export const ADD_STYLE_PREFIX_REQUEST = "ADD_STYLE_PREFIX_REQUEST";
export const ADD_STYLE_PREFIX_SUCCESS = "ADD_STYLE_PREFIX_SUCCESS";
export const ADD_STYLE_PREFIX_FAILURE = "ADD_STYLE_PREFIX_FAILURE";

export const ADD_STYLE_SUFFIX_REQUEST = "ADD_STYLE_SUFFIX_REQUEST";
export const ADD_STYLE_SUFFIX_SUCCESS = "ADD_STYLE_SUFFIX_SUCCESS";
export const ADD_STYLE_SUFFIX_FAILURE = "ADD_STYLE_SUFFIX_FAILURE";

export const ADD_COLOR_PREFIX_REQUEST = "ADD_COLOR_PREFIX_REQUEST";
export const ADD_COLOR_PREFIX_SUCCESS = "ADD_COLOR_PREFIX_SUCCESS";
export const ADD_COLOR_PREFIX_FAILURE = "ADD_COLOR_PREFIX_FAILURE";

export const ADD_COLOR_SUFFIX_REQUEST = "ADD_COLOR_SUFFIX_REQUEST";
export const ADD_COLOR_SUFFIX_SUCCESS = "ADD_COLOR_SUFFIX_SUCCESS";
export const ADD_COLOR_SUFFIX_FAILURE = "ADD_COLOR_SUFFIX_FAILURE";

export const GET_PHOTOSHOOT_REQUEST = "GET_PHOTOSHOOT_REQUEST";
export const GET_PHOTOSHOOT_SUCCESS = "GET_PHOTOSHOOT_SUCCESS";
export const GET_PHOTOSHOOT_FAILURE = "GET_PHOTOSHOOT_FAILURE";

export const EXPORT_TEMPLATE_REQUEST = "EXPORT_TEMPLATE_REQUEST";
export const EXPORT_TEMPLATE_SUCCESS = "EXPORT_TEMPLATE_SUCCESS";
export const EXPORT_TEMPLATE_FAILURE = "EXPORT_TEMPLATE_FAILURE";

export const CREATE_SESSION_REQUEST = "CREATE_SESSION_REQUEST";
export const CREATE_SESSION_SUCCESS = "CREATE_SESSION_SUCCESS";
export const CREATE_SESSION_FAILURE = "CREATE_SESSION_FAILURE";

export const GET_SESSION_REQUEST = "GET_SESSION_REQUEST";
export const GET_SESSION_SUCCESS = "GET_SESSION_SUCCESS";
export const GET_SESSION_FAILURE = "GET_SESSION_FAILURE";

export const PREPARE_FOR_EXPORT_STEP_REQUEST =
  "PREPARE_FOR_EXPORT_STEP_REQUEST";
export const PREPARE_FOR_EXPORT_STEP_SUCCESS =
  "PREPARE_FOR_EXPORT_STEP_SUCCESS";
export const PREPARE_FOR_EXPORT_STEP_FAILURE =
  "PREPARE_FOR_EXPORT_STEP_FAILURE";

export const UPDATE_FOR_EXPORT_STEP_REQUEST = "UPDATE_FOR_EXPORT_STEP_REQUEST";
export const UPDATE_FOR_EXPORT_STEP_SUCCESS = "UPDATE_FOR_EXPORT_STEP_SUCCESS";
export const UPDATE_FOR_EXPORT_STEP_FAILURE = "UPDATE_FOR_EXPORT_STEP_FAILURE";

export const GET__OLD__SKU__LIST_REQUEST = "GET__OLD__SKU__LIST_REQUEST";
export const GET__OLD__SKU__LIST_SUCCESS = "GET__OLD__SKU__LIST_SUCCESS";
export const GET__OLD__SKU__LIST_FAILURE = "GET__OLD__SKU__LIST_FAILURE";

export const GET__PORTAL_LIST__SUMMARY__HISTORY_REQUEST =
  "GET__PORTAL_LIST__SUMMARY__HISTORY_REQUEST";
export const GET__PORTAL_LIST__SUMMARY__HISTORY_SUCCESS =
  "GET__PORTAL_LIST__SUMMARY__HISTORY_SUCCESS";
export const GET__PORTAL_LIST__SUMMARY__HISTORY_FAILURE =
  "GET__PORTAL_LIST__SUMMARY__HISTORY_FAILURE";

export const GET__LISTING_QUALITY_RATING_REQUEST =
  "GET__LISTING_QUALITY_RATING_REQUEST";
export const GET__LISTING_QUALITY_RATING_SUCCESS =
  "GET__LISTING_QUALITY_RATING_SUCCESS";
export const GET__LISTING_QUALITY_RATING_FAILURE =
  "GET__LISTING_QUALITY_RATING_FAILURE";

export const GET__SITE__CODES__INVENTORY_REQUEST =
  "GET__SITE__CODES__INVENTORY_REQUEST";
export const GET__SITE__CODES__INVENTORY_SUCCESS =
  "GET__SITE__CODES__INVENTORY_SUCCESS";
export const GET__SITE__CODES__INVENTORY_FAILURE =
  "GET__SITE__CODES__INVENTORY_FAILURE";

export const ADD__COST__PRICE__SETTING_REQUEST =
  "ADD__COST__PRICE__SETTING_REQUEST";
export const ADD__COST__PRICE__SETTING_SUCCESS =
  "ADD__COST__PRICE__SETTING_SUCCESS";
export const ADD__COST__PRICE__SETTING_FAILURE =
  "ADD__COST__PRICE__SETTING_FAILURE";
export const ADD__COST__PRICE__SETTING_RESET =
  "ADD__COST__PRICE__SETTING_RESET";

export const GET__COST__PRICE__SETTING_REQUEST =
  "GET__COST__PRICE__SETTING_REQUEST";
export const GET__COST__PRICE__SETTING_SUCCESS =
  "GET__COST__PRICE__SETTING_SUCCESS";
export const GET__COST__PRICE__SETTING_FAILURE =
  "GET__COST__PRICE__SETTING_FAILURE";

export const GET_SIZES_REQUEST = "GET_SIZES_REQUEST";
export const GET_SIZES_SUCCESS = "GET_SIZES_SUCCESS";
export const GET_SIZES_FAILURE = "GET_SIZES_FAILURE";

export const GET_CATEGORIES_REQUEST = "GET_CATEGORIES_REQUEST";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_FAILURE = "GET_CATEGORIES_FAILURE";

export const ADD_COST__GROUP_REQUEST = "ADD_COST__GROUP_REQUEST";
export const ADD_COST__GROUP_SUCCESS = "ADD_COST__GROUP_SUCCESS";
export const ADD_COST__GROUP_FAILURE = "ADD_COST__GROUP_FAILURE";
export const ADD_COST__GROUP_RESET = "ADD_COST__GROUP_RESET";

export const GET__COST__GROUP__SUMMARY_REQUEST =
  "GET__COST__GROUP__SUMMARY_REQUEST";
export const GET__COST__GROUP__SUMMARY_SUCCESS =
  "GET__COST__GROUP__SUMMARY_SUCCESS";
export const GET__COST__GROUP__SUMMARY_FAILURE =
  "GET__COST__GROUP__SUMMARY_FAILURE";

export const DELETE__COST__GROUP_REQUEST = "DELETE__COST__GROUP_REQUEST";
export const DELETE__COST__GROUP_SUCCESS = "DELETE__COST__GROUP_SUCCESS";
export const DELETE__COST__GROUP_FAILURE = "DELETE__COST__GROUP_FAILURE";
export const DELETE__COST__GROUP_RESET = "DELETE__COST__GROUP_RESET";

export const GET_PRICE_BAND_REQUEST = "GET_PRICE_BAND_REQUEST";
export const GET_PRICE_BAND_SUCCESS = "GET_PRICE_BAND_SUCCESS";
export const GET_PRICE_BAND_FAILURE = "GET_PRICE_BAND_FAILURE";

export const SAVE_PRICE_BAND_REQUEST = "SAVE_PRICE_BAND_REQUEST";
export const SAVE_PRICE_BAND_SUCCESS = "SAVE_PRICE_BAND_SUCCESS";
export const SAVE_PRICE_BAND_FAILURE = "SAVE_PRICE_BAND_FAILURE";
export const SAVE_PRICE_BAND_RESET = "SAVE_PRICE_BAND_RESET";

export const GET_SUB_GROUP_COST_SUMMARY_REQUEST =
  "GET_SUB_GROUP_COST_SUMMARY_REQUEST";
export const GET_SUB_GROUP_COST_SUMMARY_SUCCESS =
  "GET_SUB_GROUP_COST_SUMMARY_SUCCESS";
export const GET_SUB_GROUP_COST_SUMMARY_FAILURE =
  "GET_SUB_GROUP_COST_SUMMARY_FAILURE";

export const ADD_CAD__MARKER_REQUEST = "ADD_CAD__MARKER_REQUEST";
export const ADD_CAD__MARKER_SUCCESS = "ADD_CAD__MARKER_SUCCESS";
export const ADD_CAD__MARKER_FAILURE = "ADD_CAD__MARKER_FAILURE";
export const ADD_CAD__MARKER_RESET = "ADD_CAD__MARKER_RESET";

export const GET__PRICE__COMPONENT_REQUEST = "GET__PRICE__COMPONENT_REQUEST";
export const GET__PRICE__COMPONENT_SUCCESS = "GET__PRICE__COMPONENT_SUCCESS";
export const GET__PRICE__COMPONENT_FAILURE = "GET__PRICE__COMPONENT_FAILURE";

export const GET__COST_GROUP_ARRAY_REQUEST = "GET__COST_GROUP_ARRAY_REQUEST";
export const GET__COST_GROUP_ARRAY_SUCCESS = "GET__COST_GROUP_ARRAY_SUCCESS";
export const GET__COST_GROUP_ARRAY_FAILURE = "GET__COST_GROUP_ARRAY_FAILURE";

export const GET__COST__PRICE__CHANGE__LOG_REQUEST =
  "GET__COST__PRICE__CHANGE__LOG_REQUEST";
export const GET__COST__PRICE__CHANGE__LOG_SUCCESS =
  "GET__COST__PRICE__CHANGE__LOG_SUCCESS";
export const GET__COST__PRICE__CHANGE__LOG_FAILURE =
  "GET__COST__PRICE__CHANGE__LOG_FAILURE";

export const UPDATE__COST__PRICE__DETAILS_REQUEST =
  "UPDATE__COST__PRICE__DETAILS_REQUEST";
export const UPDATE__COST__PRICE__DETAILS_SUCCESS =
  "UPDATE__COST__PRICE__DETAILS_SUCCESS";
export const UPDATE__COST__PRICE__DETAILS_FAILURE =
  "UPDATE__COST__PRICE__DETAILS_FAILURE";
export const UPDATE__COST__PRICE__DETAILS_RESET =
  "UPDATE__COST__PRICE__DETAILS_RESET";

export const GET_PRODUCT__STYLE__COLOR_REQUEST =
  "GET_PRODUCT__STYLE__COLOR_REQUEST";
export const GET_PRODUCT__STYLE__COLOR_SUCCESS =
  "GET_PRODUCT__STYLE__COLOR_SUCCESS";
export const GET_PRODUCT__STYLE__COLOR_FAILURE =
  "GET_PRODUCT__STYLE__COLOR_FAILURE";

export const GET_USER__LIST_REQUEST = "GET_USER__LIST_REQUEST";
export const GET_USER__LIST_SUCCESS = "GET_USER__LIST_SUCCESS";
export const GET_USER__LIST_FAILURE = "GET_USER__LIST_FAILURE";

export const GET_PRODUCT__GROUP__DETAILS_REQUEST =
  "GET_PRODUCT__GROUP__DETAILS_REQUEST";
export const GET_PRODUCT__GROUP__DETAILS_SUCCESS =
  "GET_PRODUCT__GROUP__DETAILS_SUCCESS";
export const GET_PRODUCT__GROUP__DETAILS_FAILURE =
  "GET_PRODUCT__GROUP__DETAILS_FAILURE";

export const GET_PRICE_COMPONENT_FOR__APPROVE_REJECT_REQUEST =
  "GET_PRICE_COMPONENT_FOR__APPROVE_REJECT_REQUEST";
export const GET_PRICE_COMPONENT_FOR__APPROVE_REJECT_SUCCESS =
  "GET_PRICE_COMPONENT_FOR__APPROVE_REJECT_SUCCESS";
export const GET_PRICE_COMPONENT_FOR__APPROVE_REJECT_FAILURE =
  "GET_PRICE_COMPONENT_FOR__APPROVE_REJECT_FAILURE";

export const GET_MASTER__GROUP_DATA_REQUEST = "GET_MASTER__GROUP_DATA_REQUEST";
export const GET_MASTER__GROUP_DATA_SUCCESS = "GET_MASTER__GROUP_DATA_SUCCESS";
export const GET_MASTER__GROUP_DATA_FAILURE = "GET_MASTER__GROUP_DATA_FAILURE";

export const GET_DROPDOWN_LIST_MASTER_GROUP_REQUEST =
  "GET_DROPDOWN_LIST_MASTER_GROUP_REQUEST";
export const GET_DROPDOWN_LIST_MASTER_GROUP_SUCCESS =
  "GET_DROPDOWN_LIST_MASTER_GROUP_SUCCESS";
export const GET_DROPDOWN_LIST_MASTER_GROUP_FAILURE =
  "GET_DROPDOWN_LIST_MASTER_GROUP_FAILURE";

export const CREATE_MASTER_GROUP_DATA_REQUEST =
  "CREATE_MASTER_GROUP_DATA_REQUEST";
export const CREATE_MASTER_GROUP_DATA_SUCCESS =
  "CREATE_MASTER_GROUP_DATA_SUCCESS";
export const CREATE_MASTER_GROUP_DATA_FAILURE =
  "CREATE_MASTER_GROUP_DATA_FAILURE";
export const CREATE_MASTER_GROUP_DATA_RESET = "CREATE_MASTER_GROUP_DATA_RESET";

export const GET_MASTER_PRODUCT_GROUP_LIST_REQUEST =
  "GET_MASTER_PRODUCT_GROUP_LIST_REQUEST";
export const GET_MASTER_PRODUCT_GROUP_LIST_SUCCESS =
  "GET_MASTER_PRODUCT_GROUP_LIST_SUCCESS";
export const GET_MASTER_PRODUCT_GROUP_LIST_FAILURE =
  "GET_MASTER_PRODUCT_GROUP_LIST_FAILURE";

export const ADD_REMARK_REQUEST = "ADD_REMARK_REQUEST";
export const ADD_REMARK_SUCCESS = "ADD_REMARK_SUCCESS";
export const ADD_REMARK_FAILURE = "ADD_REMARK_FAILURE";
export const ADD_REMARK_RESET = "ADD_REMARK_RESET";

export const VIEW_CAD_MARKER_REQUEST = "VIEW_CAD_MARKER_REQUEST";
export const VIEW_CAD_MARKER_SUCCESS = "VIEW_CAD_MARKER_SUCCESS";
export const VIEW_CAD_MARKER_FAILURE = "VIEW_CAD_MARKER_FAILURE";

export const GET_REMARK_REQUEST = "GET_REMARK_REQUEST";
export const GET_REMARK_SUCCESS = "GET_REMARK_SUCCESS";
export const GET_REMARK_FAILURE = "GET_REMARK_FAILURE";

export const APPROVE_REJECT_REQUEST = "APPROVE_REJECT_REQUEST";
export const APPROVE_REJECT_SUCCESS = "APPROVE_REJECT_SUCCESS";
export const APPROVE_REJECT_FAILURE = "APPROVE_REJECT_FAILURE";
export const APPROVE_REJECT_RESET = "APPROVE_REJECT_RESET";

export const GET_CONSUMPTION_PRICE_HISTORY_REQUEST =
  "GET_CONSUMPTION_PRICE_HISTORY_REQUEST";
export const GET_CONSUMPTION_PRICE_HISTORY_SUCCESS =
  "GET_CONSUMPTION_PRICE_HISTORY_SUCCESS";
export const GET_CONSUMPTION_PRICE_HISTORY_FAILURE =
  "GET_CONSUMPTION_PRICE_HISTORY_FAILURE";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
